import axios from "axios";

const API_URL = `${process.env.REACT_APP_PRODUCTS_API_URL}/wp-json/wc/v3/products`;
const consumerKey = process.env.REACT_APP_WC_CONSUMER_KEY;
const consumerSecret = process.env.REACT_APP_WC_CONSUMER_SECRET;
const token = btoa(`${consumerKey}:${consumerSecret}`);

const api = axios.create({
	baseURL: API_URL,
	headers: { Authorization: `Basic ${token}` },
});

export const fetchProducts = async () => {
	const response = await api.get("/", { params: { status: "publish" } });
	return response.data;
};

// 🔍 New search function for WooCommerce
export const searchProducts = async (searchTerm) => {
	const response = await api.get("/", { params: { search: searchTerm } });
	return response.data;
};
